"use strict";
import { useMemo, useRef } from "react";
import { useAuthToken } from "./useAuthToken";
export function useGetAuthToken() {
  const [authToken] = useAuthToken();
  const currentAuthTokenRef = useRef(authToken);
  currentAuthTokenRef.current = authToken;
  return useMemo(() => {
    return () => currentAuthTokenRef.current;
  }, []);
}
